/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Metadata_MergeInputs */



/**
* | output |
* | --- |
* | "Metadata Merge" |
*
* @param {Event_Group_Options_Metadata_MergeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_metadata_merge = /** @type {((inputs?: Event_Group_Options_Metadata_MergeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Metadata_MergeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fusion des métadonnées")
	if (locale === "de") return /** @type {LocalizedString} */ ("Metadatenzusammenführung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unione dei metadati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Объединение метаданных")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fusión de metadatos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("元数据合并")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メタデータのマージ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेटाडेटा मर्ज")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fusão de metadados")
	return /** @type {LocalizedString} */ ("Metadata Merge")
});